import { useMutation } from '@tanstack/react-query';

import { getFaireVersementSucces } from '@/services/getFaireVersementSucces/getFaireVersementSucces';
import { log } from '@/utils/functions/logger/logger';

export const useFaireVersementSucces = () => {
  return useMutation({
    mutationFn: getFaireVersementSucces,
    onError: (error) => {
      log.error(`useFaireVersementSucces failed: ${error}`);
    },
  });
};
